import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { ReceevitLogoCompact } from '../common/ReceevitLogo';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const AuthLayout = () => {
  const { openPreferences } = useCookieConsent();

  return (
    <div className="min-h-screen flex flex-col bg-[#1F11ED]">
      <header className="bg-white/10 backdrop-blur-lg border-b border-white/20 shrink-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center shrink-0" aria-label="Receevit® home">
              <ReceevitLogoCompact size={160} forBlueBackground />
            </Link>
            <Link
              to="/"
              className="text-sm text-white/80 hover:text-white transition-colors duration-200 whitespace-nowrap"
            >
              Back to home
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 w-full min-h-0 overflow-y-auto flex flex-col">
        <Outlet />
      </main>

      <footer className="bg-white/10 backdrop-blur-lg border-t border-white/20 shrink-0 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col items-center justify-center text-center gap-3 text-sm text-blue-200">
          <div className="flex flex-row flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms
            </Link>
            <Link to="/cookies" className="hover:text-white transition-colors">
              Cookies
            </Link>
            <Link to="/support" className="hover:text-white transition-colors">
              Support
            </Link>
            <button
              type="button"
              onClick={openPreferences}
              className="hover:text-white transition-colors"
            >
              Cookie preferences
            </button>
          </div>
          <span className="text-blue-300/90">
            &copy; {new Date().getFullYear()} Receevit®
          </span>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
